<template>
  <el-row>
    <el-form-item size="small" prop="promoTargetPushCart.promoValue.promoValueType" :rules="{
      required: true,
      message: 'Results tab data is required',
      trigger: 'change'
    }">
      <el-input
        v-model="Promo.promoTargetPushCart.promoValue.promoValueType"
        type="hidden"
      ></el-input>
    </el-form-item>
    <el-tabs v-model="activeName" class="tab-promo">
      <el-tab-pane label="Trigger" name="first">
        <FormTrigger :Promo="Promo" />
      </el-tab-pane>
      <el-tab-pane label="Boundary" name="second">
        <FormBoundary :Promo="Promo" />
      </el-tab-pane>
      <el-tab-pane label="Results" name="third">
        <FormResult :Promo="Promo" />
      </el-tab-pane>
    </el-tabs>
  </el-row>
</template>

<script>
import FormResult from "./FormResult";
import FormTrigger from "./FormTrigger";
import FormBoundary from "./FormBoundary";
export default {
  props: ["Promo"],
  components: {
    FormResult,
    FormTrigger,
    FormBoundary
  },
  data() {
    return {
      activeName: "first"
    };
  },
  computed: {},
  methods: {}
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
